/* SkipToContent.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _22 = "._80omtlke{cursor:pointer}";
const _21 = "._1wyb1j6v{font-size:1rem}";
const _20 = "._syaz14q2{color:var(--ds-link,#0c66e4)}";
const _19 = "._19bvidpf{padding-left:0}";
const _18 = "._n3tdidpf{padding-bottom:0}";
const _17 = "._u5f3idpf{padding-right:0}";
const _16 = "._ca0qidpf{padding-top:0}";
const _15 = "._11q7glyw{background:none}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { H6 } from '../Typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _14 = "._66dk1kli:focus-within{transform:translateY(0)}";
const _13 = "._1mygkb7n:focus-within{opacity:1}";
const _12 = "._1dig1ln4:focus-within{z-index:999999}";
const _11 = "._t9ec1i34{transform:translateY(-50%)}";
const _10 = "._tzy4idpf{opacity:0}";
const _9 = "._16qs12fg{box-shadow:0 4px 6px 5px rgba(66,82,110,.16)}";
const _8 = "._1pby1mrw{z-index:-1}";
const _7 = "._kqsw1n9t{position:fixed}";
const _6 = "._v564e9k9{transition:transform .3s cubic-bezier(.2,0,0,1) 0s}";
const _5 = "._2rko1l7b{border-radius:3px}";
const _4 = "._19itglyw{border:none}";
const _3 = "._11q71bhr{background:var(--ds-surface-overlay,#fff)}";
const _2 = "._1yt49l6b{padding:var(--ds-space-150,9pt) var(--ds-space-200,1pc)}";
const _ = "._18s8v47k{margin:var(--ds-space-250,20px)}";
export const SkipToContentStyle = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8v47k _1yt49l6b _11q71bhr _19itglyw _2rko1l7b _v564e9k9 _kqsw1n9t _1pby1mrw _16qs12fg _tzy4idpf _t9ec1i34 _1dig1ln4 _1mygkb7n _66dk1kli", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SkipToContentStyle.displayName = 'SkipToContentStyle';
}
const SkipToContentButton = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_15, _4, _16, _17, _18, _19, _20, _21, _22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz14q2 _1wyb1j6v _80omtlke", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SkipToContentButton.displayName = 'SkipToContentButton';
}
const skipToButton = {
  id: 'main-page-container',
  text: 'Skip to Main content'
};
export const SkipToContent = () => {
  const skipToHandler = event => {
    event.preventDefault();
    const element = document.getElementById(skipToButton.id);
    if (element) {
      element.focus();
    }
  };
  return /*#__PURE__*/_jsxs(SkipToContentStyle, {
    children: [/*#__PURE__*/_jsx(H6, {
      as: "p",
      children: "Skip to:"
    }), /*#__PURE__*/_jsx(SkipToContentButton, {
      onClick: skipToHandler,
      children: skipToButton.text
    })]
  });
};